var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "pagination is-small",
      attrs: { role: "navigation", "aria-label": "pagination" },
    },
    [
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentPage,
              expression: "currentPage",
            },
          ],
          staticClass: "pagination-list",
        },
        [
          _c("li", [
            _c(
              "button",
              {
                staticClass: "pagination-link is-current",
                attrs: { "aria-current": "page" },
              },
              [
                _vm._v(
                  "\n        Pág. " +
                    _vm._s(_vm.currentPage) +
                    " de " +
                    _vm._s(_vm.lastPage) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "select is-small" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sizePage,
                      expression: "sizePage",
                    },
                  ],
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.sizePage = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { domProps: { value: 5 } }, [_vm._v("5")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 10 } }, [_vm._v("10")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 20 } }, [_vm._v("20")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 30 } }, [_vm._v("30")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 50 } }, [_vm._v("50")]),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "pagination-previous",
          attrs: { disabled: !_vm.prevUrl },
          on: {
            click: function ($event) {
              return _vm.fetchData(_vm.prevUrl)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.config.prevButtonText) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "pagination-next",
          attrs: { disabled: !_vm.nextUrl },
          on: {
            click: function ($event) {
              return _vm.fetchData(_vm.nextUrl)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.config.nextButtonText) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "button",
        {
          staticClass: "pagination-link is-current",
          attrs: { "aria-current": "page" },
        },
        [_vm._v("\n        Tamaño:\n      ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }